import React, { useState } from 'react';
import './Recetari.css';

function Recetari() {
  const [activeCategory, setActiveCategory] = useState('conflictes');
  const [expandedScenario, setExpandedScenario] = useState(0);

  const categories = {
    conflictes: {
      label: 'Conflictes i sincronitzacio',
      icon: '1',
      scenarios: [
        {
          title: 'El push em rebutja amb "non-fast-forward"',
          symptom: '$ git push\nTo github.com:user/repo.git\n ! [rejected]        main -> main (non-fast-forward)\nerror: failed to push some refs\nhint: Updates were rejected because the tip of your current branch is behind\nhint: its remote counterpart.',
          why: 'Algu del teu equip ha pushejat a la mateixa branca abans que tu. La teva versio local no inclou aquells commits, i Git no et deixa sobreescriure el remot perque perdries la feina del company.',
          solution: [
            { cmd: 'git pull --rebase', out: 'Successfully rebased and updated refs/heads/main.' },
            { cmd: 'git push', out: 'To github.com:user/repo.git\n   a3f7b21..c4e8d92  main -> main' },
          ],
          solutionNote: "Si surten conflictes durant el rebase, Git pausara. Resol els fitxers marcats, fes 'git add <fitxer>' i despres 'git rebase --continue'. Si vols cancel·lar tot: 'git rebase --abort'.",
          avoid: 'Acostuma\'t a fer "git pull --rebase" abans de comencar a treballar i abans de cada push. En equip, treballa sempre en branca personal i fes PR (mai push directe a main).',
        },
        {
          title: 'Tinc conflictes en fer pull o merge',
          symptom: '$ git pull\nAuto-merging README.md\nCONFLICT (content): Merge conflict in README.md\nAutomatic merge failed; fix conflicts and then commit the result.',
          why: 'Tu i un company heu modificat les mateixes linies del mateix fitxer. Git no pot decidir quina versio val: ho has de fer tu manualment.',
          solution: [
            { cmd: 'git status', out: 'You have unmerged paths.\n  both modified:   README.md' },
            { cmd: '# Obre README.md a l\'editor i busca:', out: '' },
            { cmd: '# <<<<<<< HEAD\n# (la teva versio)\n# =======\n# (la versio del company)\n# >>>>>>> origin/main', out: '' },
            { cmd: '# Edita el fitxer deixant nomes el contingut final correcte', out: '' },
            { cmd: '# (ELIMINA els marcadors <<<<<<<, =======, >>>>>>>)', out: '' },
            { cmd: 'git add README.md', out: '' },
            { cmd: 'git commit', out: '[main 9a2b8f1] Merge branch \'main\' of github.com:user/repo' },
          ],
          solutionNote: 'NO acceptis "ours" o "theirs" a cegues: perdries la feina d\'algu. Llegeix les dues versions i decideix linia a linia. VSCode te una UI de merge molt util ("Accept Both", "Accept Current", "Accept Incoming").',
          avoid: 'Comuniqueu-vos sobre quines parts del codi toca cadascu. Feu commits petits i frequents. Sincronitzeu-vos amb main al comencar el dia.',
        },
        {
          title: 'El meu PR te conflictes a GitHub',
          symptom: 'A la pagina del PR apareix:\n"This branch has conflicts that must be resolved"\nEl boto de Merge esta desactivat.',
          why: 'Mentre treballaves a la teva branca, main ha avancat amb canvis que toquen els mateixos fitxers que tu. GitHub no pot fer el merge automaticament.',
          solution: [
            { cmd: '# En local, des de la teva branca:', out: '' },
            { cmd: 'git checkout main', out: 'Switched to branch \'main\'' },
            { cmd: 'git pull', out: 'Updating a3f7b21..c4e8d92' },
            { cmd: 'git checkout la-meva-branca', out: 'Switched to branch \'la-meva-branca\'' },
            { cmd: 'git merge main', out: 'CONFLICT (content): Merge conflict in src/app.js' },
            { cmd: '# Resol els conflictes als fitxers marcats', out: '' },
            { cmd: 'git add src/app.js', out: '' },
            { cmd: 'git commit', out: '[la-meva-branca 4d9e2a7] Merge branch \'main\' into la-meva-branca' },
            { cmd: 'git push', out: '' },
          ],
          solutionNote: 'En recarregar el PR a GitHub, els conflictes desapareixeran i el boto de Merge tornara a estar actiu.',
          avoid: 'PRs petits i de poca durada (1-2 dies maxim). Sincronitza la teva branca amb main cada dia ("git merge main" o "git rebase main").',
        },
        {
          title: 'La meva branca esta endarrerida respecte main',
          symptom: 'A GitHub veus: "This branch is 12 commits behind main".\nO en local: "Your branch is behind \'origin/main\' by 5 commits".',
          why: 'Mentre treballaves, els companys han mergejat coses a main. La teva branca no les te.',
          solution: [
            { cmd: '# Opcio A (recomanada per principiants): MERGE', out: '' },
            { cmd: 'git checkout main && git pull', out: '' },
            { cmd: 'git checkout la-meva-branca', out: '' },
            { cmd: 'git merge main', out: 'Merge made by the \'ort\' strategy.' },
            { cmd: 'git push', out: '' },
            { cmd: '', out: '' },
            { cmd: '# Opcio B (historial mes net): REBASE', out: '' },
            { cmd: 'git checkout main && git pull', out: '' },
            { cmd: 'git checkout la-meva-branca', out: '' },
            { cmd: 'git rebase main', out: 'Successfully rebased and updated refs/heads/la-meva-branca.' },
            { cmd: 'git push --force-with-lease', out: '' },
          ],
          solutionNote: 'MERGE: mes segur, manté l\'historial. REBASE: historial linial pero reescriu commits (necessita push --force-with-lease, MAI fer-ho en branques compartides amb altres companys).',
          avoid: 'Sincronitza la teva branca amb main al menys un cop al dia. PRs curts.',
        },
      ],
    },
    errors: {
      label: 'Errors humans',
      icon: '2',
      scenarios: [
        {
          title: 'He fet commit a main sense voler',
          symptom: '$ git status\nOn branch main\nYour branch is ahead of \'origin/main\' by 1 commit.\n  (use "git push" to publish your local commits)\n\n# I tu volies que aquell commit anes a una altra branca!',
          why: 'No vas crear (o canviar a) una branca abans de fer el commit. Git ha posat el teu canvi directament al main local.',
          solution: [
            { cmd: '# 1. Crea una branca nova (que apuntara al teu commit)', out: '' },
            { cmd: 'git branch feature/la-meva-feina', out: '' },
            { cmd: '', out: '' },
            { cmd: '# 2. Reseteja main al ultim commit del remot', out: '' },
            { cmd: 'git reset --hard origin/main', out: 'HEAD is now at a3f7b21 commit anterior' },
            { cmd: '', out: '' },
            { cmd: '# 3. Canvia a la branca nova (alli encara hi tens el commit)', out: '' },
            { cmd: 'git checkout feature/la-meva-feina', out: 'Switched to branch \'feature/la-meva-feina\'' },
            { cmd: 'git log --oneline -1', out: 'c4e8d92 (HEAD -> feature/la-meva-feina) la meva feina' },
            { cmd: '', out: '' },
            { cmd: '# 4. Push de la branca nova i obre PR', out: '' },
            { cmd: 'git push -u origin feature/la-meva-feina', out: '' },
          ],
          solutionNote: 'Si ja havies pushejat el commit a main: NO facis reset hard a main remot. En aquell cas: revert el commit a main i recupera\'l a una branca nova amb cherry-pick (vegeu escenari "commit a la branca equivocada").',
          avoid: 'Acostuma\'t a "git switch -c <nom-branca>" abans de comencar feina. Mira "git status" abans de cada commit per veure en quina branca estas.',
        },
        {
          title: 'He commitejat un fitxer que no havia (.env, node_modules...)',
          symptom: '$ git status\nChanges to be committed:\n  new file:   .env\n  new file:   node_modules/...\n\n# O ja ho has pushejat i veus el .env al GitHub.',
          why: 'No tens (o no tenies) un .gitignore que exclogues aquests fitxers. Per defecte, Git rastreja tot el que afegeixes.',
          solution: [
            { cmd: '# 1. Afegeix el fitxer/carpeta al .gitignore', out: '' },
            { cmd: 'echo ".env" >> .gitignore', out: '' },
            { cmd: 'echo "node_modules/" >> .gitignore', out: '' },
            { cmd: '', out: '' },
            { cmd: '# 2. Treu els fitxers del seguiment de Git (sense esborrar-los del disc)', out: '' },
            { cmd: 'git rm --cached .env', out: 'rm \'.env\'' },
            { cmd: 'git rm -r --cached node_modules', out: '' },
            { cmd: '', out: '' },
            { cmd: '# 3. Commit i push', out: '' },
            { cmd: 'git add .gitignore', out: '' },
            { cmd: 'git commit -m "chore: ignora .env i node_modules"', out: '' },
            { cmd: 'git push', out: '' },
          ],
          solutionNote: 'IMPORTANT: si el fitxer contenia secrets (passwords, tokens, claus API), ja s\'han considerar compromesos encara que els esborris. Has de ROTAR-los (canviar-los) a tot arreu on s\'utilitzin. Vegeu escenari "He pushat credencials".',
          avoid: 'Crea el .gitignore ABANS del primer commit. Per a Java: copia\'l de github.com/github/gitignore. Per a Node: "node_modules/", ".env", "dist/". Per a Python: "__pycache__/", "*.pyc", ".venv/".',
        },
        {
          title: 'He commitejat a la branca equivocada',
          symptom: 'Acabes de fer commit i adones que estaves a "main" pero el commit havia d\'anar a "feature/login". O viceversa.',
          why: 'Vas oblidar canviar de branca abans de commitejar.',
          solution: [
            { cmd: '# 1. Anota el hash del teu commit', out: '' },
            { cmd: 'git log --oneline -1', out: 'c4e8d92 feat: afegeix login' },
            { cmd: '', out: '' },
            { cmd: '# 2. Canvia a la branca correcta (on volies que anes)', out: '' },
            { cmd: 'git checkout feature/login', out: '' },
            { cmd: '', out: '' },
            { cmd: '# 3. Copia el commit aqui amb cherry-pick', out: '' },
            { cmd: 'git cherry-pick c4e8d92', out: '[feature/login d9a2e4f] feat: afegeix login' },
            { cmd: '', out: '' },
            { cmd: '# 4. Torna a la branca incorrecta i esborra el commit d\'alli', out: '' },
            { cmd: 'git checkout main', out: '' },
            { cmd: 'git reset --hard HEAD~1', out: 'HEAD is now at a3f7b21 commit anterior' },
          ],
          solutionNote: 'Si ja havies pushejat el commit a la branca incorrecta, l\'opcio mes neta es: cherry-pick a la correcta + revert (no reset) a la incorrecta. Reset hard sobre branca pushejada nomes si esta\'s 100% segur que ningu mes la fa servir.',
          avoid: 'Afegeix la branca actual al teu prompt del terminal (PS1 / starship / oh-my-posh). Aixi sempre veus on estas abans de commitejar.',
        },
      ],
    },
    desfer: {
      label: 'Desfer i recuperar',
      icon: '3',
      scenarios: [
        {
          title: 'Vull desfer l\'ultim commit (encara no he pushejat)',
          symptom: 'Has fet un commit i te n\'adones que estava malament, o que volies incloure-hi mes coses, o que ni tan sols volies fer-lo.',
          why: 'Mentre el commit nomes existeix en local, pots reescriure\'l lliurement.',
          solution: [
            { cmd: '# Variant A: descarta el commit pero mante els canvis al working dir', out: '' },
            { cmd: 'git reset --soft HEAD~1', out: '' },
            { cmd: '# (Els canvis estan a la staging area, llestos per recommitejar)', out: '' },
            { cmd: '', out: '' },
            { cmd: '# Variant B: descarta el commit i el staging, mante els canvis al disc (DEFECTE)', out: '' },
            { cmd: 'git reset HEAD~1', out: '' },
            { cmd: '# (Els canvis estan al working dir, hauras de fer git add altre cop)', out: '' },
            { cmd: '', out: '' },
            { cmd: '# Variant C: descarta TOT (commit + canvis al disc) - DESTRUCTIU', out: '' },
            { cmd: 'git reset --hard HEAD~1', out: '' },
            { cmd: '# (Els canvis es perden. Recuperables 30 dies via reflog)', out: '' },
          ],
          solutionNote: '"git commit --amend" es l\'opcio mes habitual si nomes vols modificar el missatge o afegir un fitxer mes a l\'ultim commit (sense crear-ne un de nou).',
          avoid: 'Pensa be el missatge i el contingut abans de commitejar. Fes "git diff --staged" abans de "git commit" per veure exactament que aniras a commitejar.',
        },
        {
          title: 'Vull desfer un commit ja pushejat',
          symptom: 'Has pushejat un commit que trenca alguna cosa o que conte un error. Ja esta al remot, possiblement altres companys ja se l\'han descarregat.',
          why: 'Si reescriguessis l\'historial (reset + push --force), trencaries les copies dels companys. La forma neta es crear un commit nou que desfa els canvis.',
          solution: [
            { cmd: '# 1. Identifica el commit que vols desfer', out: '' },
            { cmd: 'git log --oneline -5', out: 'c4e8d92 feat: nova funcionalitat (LA QUE VOLEM DESFER)\na3f7b21 commit anterior' },
            { cmd: '', out: '' },
            { cmd: '# 2. Crea un commit invers', out: '' },
            { cmd: 'git revert c4e8d92', out: '[main 9a2b8f1] Revert "feat: nova funcionalitat"' },
            { cmd: '# (S\'obre l\'editor amb el missatge automatic, accepta o edita)', out: '' },
            { cmd: '', out: '' },
            { cmd: '# 3. Push', out: '' },
            { cmd: 'git push', out: '' },
          ],
          solutionNote: 'Si el commit a revertir es un MERGE COMMIT, has d\'afegir "-m 1": "git revert -m 1 <hash>". Aixo li diu a Git quina de les dues branques pares mantenir.',
          avoid: 'Tests / CI abans de mergejar. Una review humana per cada PR. Mai mergejar coses sense provar-les en local.',
        },
        {
          title: 'He perdit feina despres d\'un reset o checkout',
          symptom: 'Has fet "git reset --hard" o "git checkout -- ." i has perdut canvis o commits. Estas en panic.',
          why: 'Git mante un registre intern (reflog) de TOT el que ha fet HEAD durant 30 dies, encara que aparentment hagis esborrat coses.',
          solution: [
            { cmd: '# 1. Mira el reflog (historial de moviments del HEAD)', out: '' },
            { cmd: 'git reflog', out: 'c4e8d92 HEAD@{0}: reset: moving to HEAD~3\n9a2b8f1 HEAD@{1}: commit: feat: feina perduda  <-- AIXO ES EL QUE VOLS\n4d9e2a7 HEAD@{2}: commit: anterior' },
            { cmd: '', out: '' },
            { cmd: '# 2. Recupera el commit creant una branca alli', out: '' },
            { cmd: 'git branch recuperat 9a2b8f1', out: '' },
            { cmd: 'git checkout recuperat', out: 'Switched to branch \'recuperat\'' },
            { cmd: '# Ja tens la teva feina de tornada!', out: '' },
          ],
          solutionNote: 'El reflog NOMES funciona en local. Si has clonat de nou el repo o has esborrat la carpeta .git, el reflog no et salvara. Aixo NOMES funciona per al teu propi historial local.',
          avoid: 'Abans de "reset --hard" o "checkout -- .", fes commit dels teus canvis (encara que sigui WIP) o "git stash". Si tens dubtes, NOMES fes "git status" i "git diff" primer.',
        },
        {
          title: 'Detached HEAD: "you are in detached HEAD state"',
          symptom: '$ git checkout c4e8d92\nNote: switching to \'c4e8d92\'.\n\nYou are in \'detached HEAD\' state. You can look around, make experimental\nchanges and commit them, and you can discard any commits you make in this\nstate without impacting any branches by switching back to a branch.',
          why: 'Has fet checkout d\'un hash (commit concret) en lloc d\'una branca. Estas viatjant en el temps a un punt fix de l\'historial. Qualsevol commit que facis aqui no esta lligat a cap branca i es pot perdre.',
          solution: [
            { cmd: '# Cas 1: NO vols guardar res, nomes mirar', out: '' },
            { cmd: 'git checkout main', out: 'Switched to branch \'main\'' },
            { cmd: '# (Tornes a la normalitat, sense fer res al projecte)', out: '' },
            { cmd: '', out: '' },
            { cmd: '# Cas 2: HAS fet commits aqui i els vols conservar', out: '' },
            { cmd: 'git branch nova-branca', out: '' },
            { cmd: 'git checkout nova-branca', out: '' },
            { cmd: '# Ara els teus commits estan segurs en una branca real', out: '' },
          ],
          solutionNote: 'El detached HEAD es util per a explorar versions antigues sense por de fer-hi mal. Pero MAI hi facis feina seriosa: crea una branca primer.',
          avoid: 'Quan vulguis explorar un commit antic, fes-ho directament amb "git switch --detach <hash>" (mes explicit) o crea una branca des d\'alli amb "git switch -c branca-temporal <hash>".',
        },
      ],
    },
    seguretat: {
      label: 'Seguretat',
      icon: '4',
      scenarios: [
        {
          title: 'He pushat credencials/.env per error',
          symptom: 'Has fet push d\'un fitxer .env amb passwords, o un fitxer amb tokens d\'API, claus privades, etc. Ja esta al GitHub.',
          why: 'Tot el que arriba al remot s\'ha de considerar PUBLIC, encara que el repo sigui privat (col·laboradors, possibles bots, scrapers, etc.).',
          solution: [
            { cmd: '# PAS 1 (CRITIC): rota TOTES les credencials compromeses', out: '' },
            { cmd: '# - Genera passwords/tokens/claus nous als serveis afectats', out: '' },
            { cmd: '# - Invalida els antics', out: '' },
            { cmd: '# - Esborrar-los del git NO els fa segurs altre cop', out: '' },
            { cmd: '', out: '' },
            { cmd: '# PAS 2: treu els fitxers del repo i ignora\'ls', out: '' },
            { cmd: 'echo ".env" >> .gitignore', out: '' },
            { cmd: 'git rm --cached .env', out: '' },
            { cmd: 'git commit -m "chore: elimina .env del repo"', out: '' },
            { cmd: 'git push', out: '' },
            { cmd: '', out: '' },
            { cmd: '# PAS 3 (opcional, avancat): neteja l\'historial', out: '' },
            { cmd: '# Instal·la git-filter-repo (https://github.com/newren/git-filter-repo)', out: '' },
            { cmd: 'git filter-repo --path .env --invert-paths', out: '' },
            { cmd: 'git push --force', out: '' },
            { cmd: '# AVISA tots els companys: hauran de tornar a clonar', out: '' },
          ],
          solutionNote: 'GitHub te tambe Push Protection que pot bloquejar pushes amb secrets coneguts. Activa\'l a Settings > Code security > Push protection. Si t\'arriba un correu de "GitGuardian" o GitHub Advisory, fes cas.',
          avoid: '1) .gitignore amb .env / secrets.json / *.pem / credentials.* des del dia 1. 2) Variables d\'entorn (mai hardcoded). 3) Per a configs, usa .env.example commitejat amb valors falsos i .env real ignorat. 4) Per a Java: properties files de secrets fora del repo o xifrats.',
        },
      ],
    },
  };

  const current = categories[activeCategory];
  const scenario = current.scenarios[expandedScenario] || current.scenarios[0];

  return (
    <section id="recetari" className="recetari">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Receptari</span>
          <h2 className="section-title">Que faig <span className="gold">si...?</span></h2>
          <p className="section-desc">
            Situacions reals que us trobareu treballant amb Git i GitHub. Per a cada
            problema: que veieu, per que passa, com es resol pas a pas, i com evitar-ho la propera vegada.
          </p>
        </div>

        <div className="recetari-layout">
          <div className="recetari-tabs">
            {Object.entries(categories).map(([key, cat]) => (
              <button
                key={key}
                className={`recetari-tab ${activeCategory === key ? 'active' : ''}`}
                onClick={() => { setActiveCategory(key); setExpandedScenario(0); }}
              >
                <span className="tab-icon">{cat.icon}</span>
                <span className="tab-label">{cat.label}</span>
              </button>
            ))}
          </div>

          <div className="recetari-content">
            <div className="scenario-selector">
              {current.scenarios.map((s, i) => (
                <button
                  key={i}
                  className={`scenario-pill ${expandedScenario === i ? 'active' : ''}`}
                  onClick={() => setExpandedScenario(i)}
                >
                  {s.title}
                </button>
              ))}
            </div>

            <div className="scenario-card">
              <h3 className="scenario-title">{scenario.title}</h3>

              <div className="scenario-block symptom">
                <div className="block-label">Que veieu</div>
                <div className="mini-terminal">
                  {scenario.symptom.split('\n').map((line, j) => (
                    <div key={j} className={`terminal-line ${line.startsWith('$') ? '' : 'output'}`}>
                      {line.startsWith('$') ? (
                        <>
                          <span className="prompt">$</span>
                          <span className="cmd">{line.substring(2)}</span>
                        </>
                      ) : (
                        <span className="output-text">{line}</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="scenario-block why">
                <div className="block-label">Per que passa</div>
                <p className="block-text">{scenario.why}</p>
              </div>

              <div className="scenario-block solution">
                <div className="block-label">Com es resol</div>
                <div className="mini-terminal">
                  {scenario.solution.map((line, j) => {
                    if (!line.cmd && !line.out) return <div key={j} className="terminal-line spacer">&nbsp;</div>;
                    const isComment = line.cmd.startsWith('#');
                    return (
                      <React.Fragment key={j}>
                        {line.cmd && (
                          <div className={`terminal-line ${isComment ? 'comment' : ''}`}>
                            {isComment ? (
                              <span className="comment-text">{line.cmd}</span>
                            ) : (
                              <>
                                <span className="prompt">$</span>
                                <span className="cmd">{line.cmd}</span>
                              </>
                            )}
                          </div>
                        )}
                        {line.out && line.out.split('\n').map((outLine, k) => (
                          <div key={`o${k}`} className="terminal-line output">
                            <span className="output-text">{outLine}</span>
                          </div>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </div>
                {scenario.solutionNote && (
                  <p className="solution-note">{scenario.solutionNote}</p>
                )}
              </div>

              <div className="scenario-block avoid">
                <div className="block-label">Com evitar-ho</div>
                <p className="block-text">{scenario.avoid}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Recetari;
